module.exports = __webpack_public_path__ + "img/icon-gas-water-heater-stove.596d56c9.svg";